import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { FloatLabelType, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

export type XpSearchFieldType = 'text' | 'search';

@Component({
	selector: 'xp-search-field',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule
	],
	templateUrl: './xp-search-field.component.html',
	styleUrls: ['./xp-search-field.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpSearchFieldComponent {
	placeholder = input('');
	ariaLabel = input<string | null>(null);
	label = input<string | null>(null);
	floatLabel = input<FloatLabelType>('auto');
	type = input<XpSearchFieldType>('text');
	showClear = input(false);
	/* The Material trigger throws on a null panel, so the template keeps a branch without it. */
	autocomplete = input<MatAutocomplete | null>(null);
	value = model('');
	clear = output<void>();

	onInput(text: string): void {
		this.value.set(text);
	}
}
